module.exports = __webpack_public_path__ + "static/media/Artboard8.eab34831.png";